/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 12:05:14
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/Tags/SimpleProductTagsSection.tsx
 */
import React, { useState } from 'react';
import Tags from '../../Components/Tags/Tags';
import { useSelector } from 'react-redux';
import { setTags } from '../Slice';

const TagsSection = (props) => {
  const tags = useSelector((state: any) => state.simpleProduct.tags.tags);

  const [inputTags, setInputTags] = useState('');
  const { disabled } = props || {};
  return (
    <Tags
      disabled={disabled}
      setInputTags={setInputTags}
      tags={tags}
      inputTags={inputTags}
      setTags={setTags}
    />
  );
};
export default TagsSection;
